import React from 'react';
import { Bar } from 'react-chartjs-2';
import { barChartOptions } from '../../utils/charts';

interface BarChartProps {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    backgroundColor?: string | string[];
    borderColor?: string | string[];
  }[];
  options?: any;
}

const BarChart: React.FC<BarChartProps> = ({ labels, datasets, options }) => {
  const data = {
    labels,
    datasets: datasets.map((dataset) => ({
      ...dataset,
      backgroundColor: dataset.backgroundColor || 'rgba(79, 211, 136, 0.6)',
      borderColor: dataset.borderColor || 'rgba(79, 211, 136, 1)',
      fill: true,
    })),
  };

  return <Bar data={data} options={options || barChartOptions} />;
};

export default BarChart;

